// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notification-date[data-v-07ce93e4] {\n  padding: 2px 0 0 4px;\n}\n", ""]);
// Exports
module.exports = exports;
